export default __webpack_public_path__ + "static/media/car-insur-bf-quotes.6d4288fb.jpg";